<template>
<div class="bord clear recommend" id="recommend-writer" data-spm="mp">
    <div class="author-subscribe">
       <header class="header" data-spm="author-subscribe-nav">
            <a class="title" :href="url " target="_blank">
                {{ title }}
            </a>
        </header>

        <div data-spm="author-subscribe">
            <div class="container-box" v-for="(item, index) in data" :key="index">
                <a class="content-left" :href="item.authorHomePage" target="_blank">
                    <img class="avatar" :src="item.authorCover" />
                    <div class="name">
                        {{ item.authorName }}
                    </div>
                </a>
                <a class="content-right" :href="item.url " target="_blank">
                    <div class="article">
                        {{ item.title }}
                    </div>
                </a>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import { setPicSize } from "../../utils/pic-util.js"
import { getOdinResourceIdMap } from '@/config/odinResourceIds'
import { getOdinData,formatOdinData } from "@/request/odinRequest"

export default {
    data() {
        return {
            title:'搜狐号',
            url:'https://www.sohu.com/xtopic/TURBd01EVTVNRFU0',
            data:[],
        }
    },
    mounted() {
        this.getData()

    },
    methods: {
        async getData() {
            const spmObj = window?.sohuSpm?.getCodes()
            const senceKey = 'recommendWriter'
            const idsMap = getOdinResourceIdMap(senceKey)
            const param = {
                tplCompKey: senceKey,
                adInfo: idsMap?.adInfo,
                spmCCode: idsMap?.spmCCode,
                resourceId: idsMap?.resourceId,
                content: {
                    page: 1,
                    size: 6,
                    productId: idsMap?.productId,
                    productType: idsMap?.productType,
                    spm: `${spmObj?.a}.${spmObj?.b}.${idsMap?.spmCCode}`
                },
                context:{
                    mkey: "channelId_" + window.pcArticleInfo?.channel_id + "--mpid_" + window.pcArticleInfo?.news_id
                }
            }
            try {
                let res = await getOdinData(param)
                if(res?.list?.length) {
                    let list = formatOdinData(res)
                    list.forEach((item)=>{
                        if(item?.authorCover){
                            item.authorCover = setPicSize(item.authorCover, 64, 64)
                        }
                    })
                    this.data = list
                    this.$nextTick(()=>{
                        window.sohuSpm?.domDidChange({target: 'mp'});
                    })
                }
            } catch (error) {
                console.log('搜狐号推荐',error)
            }
        },
    }
}
</script>

<style lang="less" scoped>
.recommend{padding-bottom:10px;height:auto;}
.author-subscribe {
    width: 100%;
    background: white;
    box-sizing: border-box;
    padding: 16px 20px;
    a{
        display: inline-block;
    }
    .header {
        padding-bottom: 2px;
        .title{
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight:bold;
            font-size:20px;
            height:25px;
            color:#191919;
            line-height:25px;
        }
    }
    .container-box{
        width: 100%;
        height: 84px;
        box-shadow: inset 0px -1px 0px 0px #EBEBEB;
        .content-left{
            width: 72px;
            text-align: center;
            height: 84px;
            padding-top: 14px;
            padding-bottom: 14px;
            box-sizing: border-box;
            &:hover {
                color: #C9141D;
            }
            .avatar{
                width: 32px;
                height: 32px;
                border-radius: 50%;
                margin: 0 auto;
            }
            .name{
                width: 100%;
                height: 20px;
                font-size: 14px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #111111;
                line-height: 20px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                text-align: center;
            }
        }
        .content-right{
            position: relative;
            top: 50%;
            transform: translateY(-50%);
            vertical-align: top;
            width: 212px;
            .article{
                width: 202px;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #404040;
                line-height: 20px;
                margin-left: 10px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                -webkit-box-orient: vertical;
                &:hover{
                    color: #C9141D;
                }
            }
        }
    }
}
</style>